import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import {useRecordModuleHistory} from '../../contexts/module-history-context';
import {OptionsQueryDocument, useUpdateOptionMutation} from "../../generated/graphql";
import {SideList} from "../../components/SideList";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";

const Options = () => {
    const location = useLocation();
    const updateMutation = useUpdateOptionMutation();
    const recordModuleHistory = useRecordModuleHistory();
    useEffect(()=> {
        recordModuleHistory('options');
    },[recordModuleHistory,location]);
    const columns: FieldTableColumnProps<any>[] = [
        {
            accessor: 'label',
            header: 'Option Name',
            dataType:'link',
            className: 'column-width-wide-plus',
            // eslint-disable-next-line react/display-name
            options: {
                getLink: ({field, row}) => {
                    return ({
                        pathname: '/settings/options/' + (row.id)
                    });
                }
            }
        }, {
            accessor: 'type',
            header: 'Type',
            dataType:'default'
        }
    ];
    return <SideList searchForm={null} query={OptionsQueryDocument} baseUrl="/settings/options/" label="Options" columns={columns}
    deleteMutation={updateMutation}
    />;
};

export default Options;
